module.exports = __webpack_public_path__ + "images/onboarding/nick_paridon.jpg";